import { createRoot } from 'react-dom/client';
import { createClientTransport, readBootstrap } from '../bridge/client-transport';
import { SheetsClientApp } from './App';
import './styles.css';

/**
 * Engine client entry point.
 *
 * Reads the host-injected bootstrap (`window.__CHARTFORGE__`), builds the
 * transport the host asked for, and mounts the shared engine UI. The sidebar
 * decides *where* this file runs; this file never talks to Google APIs
 * directly — only to the typed bridge.
 */
function main(): void {
  const root = document.getElementById('root');
  if (!root) {
    throw new Error('Charts by Nex Flow Automation client requires a #root element');
  }
  const { bootstrap, problems } = readBootstrap();
  const transport = createClientTransport(bootstrap);
  createRoot(root).render(
    <SheetsClientApp bootstrap={bootstrap} transport={transport} notices={problems} />
  );
}

main();
